<template>
	<div class="ar-page">
		<DetailPage v-if="detail" :detail="detail" @back="detail = null" />
		<div v-else class="ar-inner">
			<!-- 关键字搜索栏 -->
			<div class="ar-bar">
				<div class="ar-group">
					<label>关键字搜索：</label>
					<input v-model="filter.keyword" type="text" placeholder="请输入查询关键字" @keyup.enter="query" />
				</div>
				<button class="ar-query" @click="query">查询</button>
				<button class="ar-reset" @click="reset">重置</button>
			</div>

			<!-- 日度 / 周度 / 月度 报告 tab -->
			<div class="ar-tabs">
				<div v-for="(t, i) in tabs" :key="t" class="ar-tab" :class="{ active: tab === i }" @click="switchTab(i)">
					{{ t }}</div>
			</div>

			<!-- 列表 -->
			<div class="ar-list">
				<div v-for="item in pagedList" :key="item.id" class="ar-item" @click="goInfo(item)">
					<div class="ar-date">
						<span class="d-ym">{{ item.ym }}</span>
						<span class="d-day">{{ item.day }}</span>
					</div>
					<div class="ar-main">
						<div class="ar-head">
							<div class="ar-title">{{ item.title }}</div>
							<div class="ar-source">来源：{{ item.source }}</div>
						</div>
						<div class="ar-summary">{{ item.summary }}</div>
					</div>
				</div>
				<div v-if="!loading && !pagedList.length" class="ar-empty">暂无相关报告</div>
				<div class="ar-mask" v-if="loading">
					<span class="ar-spin"></span>
					<span class="ar-mask-text">加载中…</span>
				</div>
			</div>

			<!-- 分页 -->
			<div class="ar-pager">
				<span class="pg-total">共 {{ total }} 条</span>
				<span class="pg-btn" :class="{ disabled: page <= 1 }" @click="changePage(page - 1)">上一页</span>
				<span v-for="(p, idx) in visiblePages" :key="'pg' + idx" class="pg-num" :class="{ active: p === page, ellipsis: p === '...' }" @click="p !== '...' && changePage(p)">{{ p }}</span>
				<span class="pg-btn" :class="{ disabled: page >= pageCount }" @click="changePage(page + 1)">下一页</span>
			</div>
		</div>
	</div>
</template>

<script>
	import DetailPage from './DetailPage.vue'

	const SRC = '农业农村部市场与信息化司'

	export default {
		name: 'AnalysisReport',
		components: { DetailPage },
		data() {
			return {
				tabs: ['日度报告', '周度报告', '月度报告'],
				tab: 0,
				filter: { keyword: '' },
				applied: { keyword: '' },
				page: 1,
				pageSize: 10,
				// 服务端分页：当前页报告、总量、加载态
				reportList: [],
				total: 0,
				loading: false,
				// 当前选中展示的报告详情（非空则显示 DetailPage）
				detail: null,
				// 分析报告（假数据，接口就绪后不再使用，保留兜底）
				reportMap: {
					0: [{
							id: 201, ym: '2026/10', day: '29', source: SRC,
							title: '10月29日：“农产品批发价格200指数”比昨天下降0.11个点。',
							summary: '据农业农村部监测，10月29日“农产品批发价格200指数”为111.42，比昨天下降0.11个点，“菜篮子”产品批发价格指数为110.97，比昨天下降0.13个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为15.38元/公斤，比昨天下降1.3%；牛肉73.32元/公斤，比昨天下降0.2%；羊肉67.38元/公斤，比昨……'
						}, {
							id: 202, ym: '2026/10', day: '28', source: SRC,
							title: '10月28日：“农产品批发价格200指数”比昨天下降0.05个点。',
							summary: '据农业农村部监测，10月28日“农产品批发价格200指数”为111.53，比昨天下降0.05个点，“菜篮子”产品批发价格指数为111.10，比昨天下降0.05个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为15.59元/公斤，比昨天下降0.7%；牛肉73.45元/公斤，比昨天上升0.2%；羊肉67.30元/公斤，比昨……'
						}, {
							id: 203, ym: '2026/10', day: '27', source: SRC,
							title: '10月27日：“农产品批发价格200指数”比昨天下降0.06个点。',
							summary: '据农业农村部监测，10月27日“农产品批发价格200指数”为111.58，比昨天下降0.06个点，“菜篮子”产品批发价格指数为111.15，比昨天下降0.07个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为15.70元/公斤，比昨天下降0.8%；牛肉73.29元/公斤，比昨天上升0.7%；羊肉67.49元/公斤，比昨……'
						}, {
							id: 204, ym: '2026/10', day: '26', source: SRC,
							title: '10月26日：“农产品批发价格200指数”比上周五上升0.06个点。',
							summary: '据农业农村部监测，10月26日“农产品批发价格200指数”为111.64，比上周五上升0.06个点，“菜篮子”产品批发价格指数为111.22，比上周五上升0.08个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为15.83元/公斤，比上周五上升0.1%；牛肉72.81元/公斤，比上周五上升0.3%；羊肉67.06元/公……'
						}, {
							id: 205, ym: '2026/10', day: '23', source: SRC,
							title: '10月23日：“农产品批发价格200指数”比昨天下降0.15个点。',
							summary: '据农业农村部监测，10月23日“农产品批发价格200指数”为111.58，比昨天下降0.15个点，“菜篮子”产品批发价格指数为111.14，比昨天下降0.18个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为15.82元/公斤，比昨天上升0.6%；牛肉72.60元/公斤，与昨天持平；羊肉67.74元/公斤，比昨天上升1……'
						}, {
							id: 206, ym: '2026/10', day: '22', source: SRC,
							title: '10月22日：“农产品批发价格200指数”比昨天下降0.27个点。',
							summary: '据农业农村部监测，10月22日“农产品批发价格200指数”为111.73，比昨天下降0.27个点，“菜篮子”产品批发价格指数为111.32，比昨天下降0.32个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为15.73元/公斤，比昨天下降0.2%；牛肉72.62元/公斤，比昨天下降0.3%；羊肉67.00元/公斤，比昨……'
						}, {
							id: 207, ym: '2026/10', day: '21', source: SRC,
							title: '10月21日：“农产品批发价格200指数”比昨天上升0.22个点。',
							summary: '据农业农村部监测，10月21日“农产品批发价格200指数”为112.00，比昨天上升0.22个点，“菜篮子”产品批发价格指数为111.64，比昨天上升0.25个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为15.76元/公斤，比昨天下降0.6%；牛肉72.81元/公斤，比昨天下降1.0%；羊肉67.32元/公斤，比昨……'
						}, {
							id: 208, ym: '2026/10', day: '20', source: SRC,
							title: '10月20日：“农产品批发价格200指数”比昨天下降0.55个点。',
							summary: '据农业农村部监测，10月20日“农产品批发价格200指数”为111.78，比昨天下降0.55个点，“菜篮子”产品批发价格指数为111.39，比昨天下降0.62个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为15.85元/公斤，比昨天下降0.4%；牛肉73.54元/公斤，比昨天上升0.1%；羊肉67.41元/公斤，比昨……'
						}, {
							id: 209, ym: '2026/10', day: '19', source: SRC,
							title: '10月19日：“农产品批发价格200指数”比上周五下降0.31个点。',
							summary: '据农业农村部监测，10月19日“农产品批发价格200指数”为112.33，比上周五下降0.31个点，“菜篮子”产品批发价格指数为111.98，比上周五下降0.35个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为15.92元/公斤，比上周五下降0.5%；牛肉73.47元/公斤，比上周五上升0.2%……'
						}, {
							id: 210, ym: '2026/10', day: '16', source: SRC,
							title: '10月16日：“农产品批发价格200指数”比昨天上升0.08个点。',
							summary: '据农业农村部监测，10月16日“农产品批发价格200指数”为112.64，比昨天上升0.08个点，“菜篮子”产品批发价格指数为112.31，比昨天上升0.10个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为16.05元/公斤，比昨天上升0.3%；牛肉73.28元/公斤，比昨天下降0.1%……'
						}, {
							id: 211, ym: '2026/10', day: '15', source: SRC,
							title: '10月15日：“农产品批发价格200指数”比昨天下降0.12个点。',
							summary: '据农业农村部监测，10月15日“农产品批发价格200指数”为112.56，比昨天下降0.12个点，“菜篮子”产品批发价格指数为112.21，比昨天下降0.14个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为16.00元/公斤，比昨天下降0.2%；牛肉73.35元/公斤，比昨天上升0.1%……'
						}, {
							id: 212, ym: '2026/10', day: '14', source: SRC,
							title: '10月14日：“农产品批发价格200指数”比昨天上升0.05个点。',
							summary: '据农业农村部监测，10月14日“农产品批发价格200指数”为112.68，比昨天上升0.05个点，“菜篮子”产品批发价格指数为112.35，比昨天上升0.06个点。截至今日14:00时，全国农产品批发市场猪肉平均价格为16.03元/公斤，比昨天上升0.1%；牛肉73.28元/公斤，与昨天持平……'
						},
					],
					1: [{
							id: 301, ym: '2026/10', day: '26', source: SRC,
							title: '2026年第43周“农产品批发价格200指数”周报：菜价稳中有跌。',
							summary: '本周（10.20-10.26）“农产品批发价格200指数”日均值111.72，环比上周下跌0.4%。“菜篮子”产品批发价格指数日均值111.31，环比下跌0.5%。重点监测的28种蔬菜平均价格为4.12元/公斤，环比下跌1.2%；猪肉平均价格15.78元/公斤，环比下跌0.6%……'
						}, {
							id: 302, ym: '2026/10', day: '19', source: SRC,
							title: '2026年第42周“农产品批发价格200指数”周报：整体保持平稳。',
							summary: '本周（10.13-10.19）“农产品批发价格200指数”日均值112.15，环比上周上涨0.2%。“菜篮子”产品批发价格指数日均值111.78，环比上涨0.3%。28种蔬菜平均价格4.17元/公斤，环比上涨0.8%；猪肉平均价格15.88元/公斤，环比上涨0.3%……'
						}, {
							id: 303, ym: '2026/10', day: '12', source: SRC,
							title: '2026年第41周“农产品批发价格200指数”周报：水果价格走高。',
							summary: '本周（10.6-10.12）“农产品批发价格200指数”日均值111.92，环比上涨0.1%。“菜篮子”产品批发价格指数日均值111.55，环比持平。6种水果平均价格7.85元/公斤，环比上涨1.5%；鸡蛋平均价格8.20元/公斤，环比下跌0.9%……'
						}, {
							id: 304, ym: '2026/10', day: '08', source: SRC,
							title: '2026年第40周“农产品批发价格200指数”周报：节后市价回落。',
							summary: '本周（9.29-10.5）“农产品批发价格200指数”日均值111.80，环比下跌0.6%。“菜篮子”产品批发价格指数日均值111.42，环比下跌0.7%。国庆假期后需求回落，猪肉、蔬菜价格普遍走低，牛肉、羊肉价格保持稳定……'
						}, {
							id: 305, ym: '2026/09', day: '28', source: SRC,
							title: '2026年第39周“农产品批发价格200指数”周报：节前备货走强。',
							summary: '本周（9.22-9.28）“农产品批发价格200指数”日均值112.50，环比上涨0.5%。“菜篮子”产品批发价格指数日均值112.20，环比上涨0.6%。中秋、国庆双节备货带动，肉蛋奶及蔬菜价格普遍上行，水果价格稳中略涨……'
						},
					],
					2: [{
							id: 401, ym: '2026/10', day: '08', source: SRC,
							title: '2026年9月“农产品批发价格200指数”月度报告。',
							summary: '9月份“农产品批发价格200指数”月均值为112.30，环比8月上涨1.2%，同比上涨3.5%。“菜篮子”产品批发价格指数月均值112.00，环比上涨1.4%。分品类看，猪肉、蔬菜价格环比走强，粮食、食用油价格保持稳定，水果价格先涨后落……'
						}, {
							id: 402, ym: '2026/09', day: '08', source: SRC,
							title: '2026年8月“农产品批发价格200指数”月度报告。',
							summary: '8月份“农产品批发价格200指数”月均值为111.00，环比7月下跌0.8%，同比上涨2.1%。“菜篮子”产品批发价格指数月均值110.65，环比下跌0.9%。受高温及供应充足影响，蔬菜、鸡蛋价格环比回落，猪肉价格震荡走强……'
						}, {
							id: 403, ym: '2026/08', day: '08', source: SRC,
							title: '2026年7月“农产品批发价格200指数”月度报告。',
							summary: '7月份“农产品批发价格200指数”月均值为111.90，环比6月上涨0.6%，同比上涨2.8%。“菜篮子”产品批发价格指数月均值111.60，环比上涨0.7%。雨季影响叶菜生产运输，蔬菜价格环比上涨；猪肉价格触底回升……'
						}, {
							id: 404, ym: '2026/07', day: '08', source: SRC,
							title: '2026年6月“农产品批发价格200指数”月度报告。',
							summary: '6月份“农产品批发价格200指数”月均值为111.20，环比5月下跌1.1%，同比上涨1.9%。“菜篮子”产品批发价格指数月均值110.90，环比下跌1.2%。夏季蔬菜大量上市，价格季节性回落；水果供应充足价格走低……'
						}, {
							id: 405, ym: '2026/06', day: '08', source: SRC,
							title: '2026年5月“农产品批发价格200指数”月度报告。',
							summary: '5月份“农产品批发价格200指数”月均值为112.45，环比4月下跌0.5%，同比上涨2.3%。“菜篮子”产品批发价格指数月均值112.20，环比下跌0.6%。猪肉价格延续回落，禽蛋、蔬菜价格稳中有降，粮食价格保持稳定……'
						},
					],
				},
			}
		},
		computed: {
			pageCount() {
				return Math.max(1, Math.ceil(this.total / this.pageSize))
			},
			// 页码窗口：总页数不多时全显；否则 首页 … 当前±2 … 末页（'...' 为省略占位）
			visiblePages() {
				const total = this.pageCount, cur = this.page, out = []
				if (total <= 7) {
					for (let i = 1; i <= total; i++) out.push(i)
					return out
				}
				out.push(1)
				let start = Math.max(2, cur - 2)
				let end = Math.min(total - 1, cur + 2)
				if (cur <= 3) { start = 2; end = 5 }
				if (cur >= total - 2) { start = total - 4; end = total - 1 }
				if (start > 2) out.push('...')
				for (let i = start; i <= end; i++) out.push(i)
				if (end < total - 1) out.push('...')
				out.push(total)
				return out
			},
			pagedList() {
				return this.reportList
			},
		},
		mounted() {
			this.fetchReports()
		},
		methods: {
			switchTab(i) {
				this.tab = i
				this.page = 1
				this.fetchReports()
			},
			query() {
				this.page = 1
				this.fetchReports()
			},
			reset() {
				this.filter = { keyword: '' }
				this.page = 1
				this.fetchReports()
			},
			changePage(p) {
				if (p < 1 || p > this.pageCount || p === this.page) return
				this.page = p
				this.fetchReports()
			},
			// 分析报告服务端分页：category=2，period 随 tab（日/周/月 → 1/2/3）
			fetchReports() {
				if (this.loading) return
				this.loading = true
				const params = {
					pageNo: this.page,
					pageSize: this.pageSize,
					category: 2,
					period: this.tab + 1,
				}
				const kw = (this.filter.keyword || '').trim()
				if (kw) params.keyword = kw
				this.$request2('/admin-api/governance/pfsc-source-data/item-page', { params }).then(res => {
					if (!res || res.code !== 0 || !res.data || !Array.isArray(res.data.list)) {
						this.reportList = []
						this.total = 0
						return
					}
					this.reportList = res.data.list.map(it => this.mapReportRow(it))
					
					this.total = res.data.total || 0
				}).catch(() => {
					this.reportList = []
					this.total = 0
				}).then(() => {
					this.loading = false
				})
			},
			mapReportRow(it) {
				let obj = null
				try { obj = JSON.parse(it.data) } catch (e) { obj = null }
				obj = obj || {}
				const title = obj.remark || obj.counclesion || obj.indexConclusion || it.dataDate || '分析报告'
				const html = obj.countent || obj.content || ''
				// 正文优先级：纯文本字段 → 总结类字段 → HTML 正文去标签兜底
				const plain = obj.countentstr || obj.contentstr || obj.counclesion || obj.indexConclusion || obj.incOrReduRange || this.stripHtml(html)
				const summary = String(plain).replace(/\s+/g, ' ').trim()
				const parts = this.parseDateParts(obj.daylyDate || obj.publishDate || it.dataDate || '')
				return {
					id: it.id,
					ym: parts.ym,
					day: parts.day,
					date: obj.daylyDate || obj.publishDate || it.dataDate || '',
					source: obj.source || SRC,
					title: title,
					summary: summary,
					html: html,
					text: plain,
				}
			},
			// 去 HTML 标签，将富文本正文转为可读纯文本（用于 summary 兜底）
			stripHtml(s) {
				if (!s) return ''
				return String(s).replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim()
			},
			parseDateParts(str) {
				let m = String(str).match(/(\d{4})-(\d{2})-(\d{2})/)
				if (!m) m = String(str).match(/(\d{4})\.(\d{2})\.(\d{2})/)
				if (!m) m = String(str).match(/(\d{4})(\d{2})(\d{2})/)
				if (m) return { ym: m[1] + '/' + m[2], day: m[3] }
				return { ym: '', day: '' }
			},
			goInfo(item) {
				if (!item) return
				this.detail = {
					title: item.title,
					source: item.source,
					date: item.date,
					html: item.html,
					text: item.text,
				}
			},
		},
	}
</script>

<style scoped lang="scss">
	.ar-page {
		flex: 1;
		min-height: 0;
		overflow: auto;
		background: #fff;
		box-sizing: border-box;
	}

	.ar-inner {
		max-width: 1300px;
		margin: 0 auto;
		padding: 20px;
	}

	/* ===== 关键字搜索栏 ===== */
	.ar-bar {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 16px;
		padding: 16px 20px;
		background: #f5f7f9;
		border-radius: 6px;
		box-sizing: border-box;
	}

	.ar-group {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #666;
	}

	.ar-group label {
		white-space: nowrap;
	}

	.ar-group input {
		width: 220px;
		height: 34px;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		padding: 0 10px;
		font-size: 14px;
		color: #333;
		outline: none;
		box-sizing: border-box;
	}

	.ar-query {
		height: 34px;
		padding: 0 28px;
		background: #22b573;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
	}

	.ar-query:hover {
		background: #1ea166;
	}

	.ar-reset {
		height: 34px;
		padding: 0 28px;
		background: #fff;
		color: #22b573;
		border: 1px solid #22b573;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
	}

	/* ===== tab ===== */
	.ar-tabs {
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-top: 20px;
		border-bottom: 1px solid #e5e5e5;
	}

	.ar-tab {
		position: relative;
		padding: 12px 6px;
		font-size: 16px;
		color: #333;
		cursor: pointer;
	}

	.ar-tab.active {
		color: #22b573;
		font-weight: 600;
	}

	.ar-tab.active::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: -1px;
		height: 2px;
		background: #22b573;
	}

	/* ===== 列表 ===== */
	.ar-list {
		position: relative;
		margin-top: 6px;
		min-height: 120px;
	}

	.ar-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;
		background: rgba(255, 255, 255, .75);
		border-radius: 6px;
		z-index: 2;
	}

	.ar-spin {
		width: 30px;
		height: 30px;
		border: 3px solid #d7f5e6;
		border-top-color: #22b573;
		border-radius: 50%;
		animation: ar-spin .8s linear infinite;
	}

	@keyframes ar-spin {
		to {
			transform: rotate(360deg);
		}
	}

	.ar-mask-text {
		font-size: 14px;
		color: #22b573;
	}

	.ar-item {
		display: flex;
		align-items: flex-start;
		padding: 20px 0;
		border-bottom: 1px solid #f0f0f0;
		cursor: pointer;
	}

	.ar-item:hover .ar-title {
		color: #22b573;
	}

	.ar-date {
		flex: 0 0 76px;
		width: 76px;
		height: 76px;
		margin-right: 18px;
		border: 1px solid #e64b3c;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #e64b3c;
	}

	.d-ym {
		font-size: 13px;
	}

	.d-day {
		font-size: 30px;
		font-weight: 700;
		line-height: 1.1;
	}

	.ar-main {
		flex: 1;
		min-width: 0;
	}

	.ar-head {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
	}

	.ar-title {
		flex: 1;
		min-width: 0;
		font-size: 17px;
		font-weight: 700;
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.ar-source {
		flex: 0 0 auto;
		max-width: 260px;
		margin-left: 16px;
		font-size: 13px;
		color: #999;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.ar-summary {
		margin-top: 10px;
		font-size: 14px;
		line-height: 1.7;
		color: #888;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.ar-empty {
		padding: 60px 0;
		text-align: center;
		font-size: 15px;
		color: #999;
	}

	/* ===== 分页 ===== */
	.ar-pager {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 8px;
		margin-top: 20px;
		font-size: 14px;
		color: #666;
	}

	.pg-total {
		margin-right: auto;
	}

	.pg-btn,
	.pg-num {
		min-width: 34px;
		height: 34px;
		line-height: 32px;
		padding: 0 12px;
		text-align: center;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		background: #fff;
		color: #333;
		cursor: pointer;
		box-sizing: border-box;
		user-select: none;
	}

	.pg-btn:hover,
	.pg-num:hover {
		border-color: #22b573;
		color: #22b573;
	}

	.pg-num.active {
		background: #22b573;
		border-color: #22b573;
		color: #fff;
	}

	.pg-num.ellipsis {
		border: none;
		background: transparent;
		cursor: default;
		color: #999;
	}

	.pg-num.ellipsis:hover {
		border: none;
		color: #999;
	}

	.pg-btn.disabled {
		color: #c0c4cc;
		border-color: #ebeef5;
		cursor: not-allowed;
	}

	.pg-btn.disabled:hover {
		color: #c0c4cc;
		border-color: #ebeef5;
	}
</style>
